<template>
  <a href="/2014/Poster.pdf" target="_blank">
    <img
      src="/2014/poster_2014_lg.jpg"
      alt="poster"
      class="poster"
      title="Click here to download the VIZBI conference poster" />
  </a>
  <p>
    The 2nd EMBO Conference on Visualizing Biological Data (VIZBI 2014) &mdash; also the
    5<sup>th</sup> international meeting on this topic &mdash; was held from the 5<sup>th</sup> to
    the 7<sup>th</sup> of March 2014 at
    <a href="http://www.embl.de/">EMBL-Heidelberg</a> in Germany. VIZBI brings together scientists,
    illustrators, and designers actively using or developing computational visualization to study a
    diverse range of biological data.
  </p>
  <p>
    The conference featured
    <router-link to="People">21 invited talks</router-link> that reviewed the state-of-the-art and
    challenges in visualizing data from genomes, transcripts, proteins, cells, organisms, and
    populations. Prior to the meeting, on 4<sup>th</sup> March, were 12 tutorials on key
    visualization tools &amp; methods.
  </p>
  <p>
    All VIZBI 2014 participants had the opportunity to present a poster describing their work. Just
    before each poster session, presenters had about 60 seconds to briefly introduce themselves and
    their poster to all VIZBI participants (details
    <router-link to="Posters">here</router-link>).
  </p>
  <p>
    <router-link to="Registration">Registration</router-link> was on a first-come, first-served
    basis with limited places. Virtual registration allowed participation via streaming video and
    chat. A limited number of EMBL ATC Corporate Partnership Programme (CPP) fellowships provided
    registration fee waivers and travel grants.
  </p>
</template>

<style scoped>
img.poster {
  float: right;
  margin: 0 0 12px 12px;
  max-width: 260px;
  width: 40%;
  height: auto;
}
</style>
